import { AddMoreInput } from './add-more-input';
import { AddToCartButton } from './add-to-cart-button';
import { Aktuelles } from './aktuelles';
import { AlphabeticListing } from './alphabetic-listing';
import { ArticlesOverview } from './articles-overview';
import { BlacktriangleText } from './blacktriangle-text';
import { BusinessCard } from './business-card';
import { Cart } from './cart';
import { CategoriesList } from './categories-list';
import { CognitoRegistration } from './cognito-registration';
import { DidArticlePage } from './did-article-page';
import { DidArticlesList } from './did-articles-list';
import { DynamicEventTeaser } from './dynamic-event-teaser';
import { DynamicPodcastTeaser } from './dynamic-podcast-teaser';
import { DynamicTeaser } from './dynamic-teaser';
import { forms } from './forms';
import { gridComponents } from './grid';
import { HtmlBlob } from './html-blob';
import { Marketo } from './marketo';
import { OrderDetailsForm } from './checkout/order-details-form';
import { Page } from './page';
import { PageEvent } from './page-event';
import { PagePressNews } from './page-press-news';
import { PagePressOverview } from './page-press-overview';
import { PageProduct } from './page-product';
import { PatientenBetroffene } from './patienten-betroffene';
import { PlaceOrderForm } from './checkout/place-order-form';
import { ProductCatalog } from './product-catalog';
import { Produkt } from './produkt';
import { responsiveTable } from './responsive-table';
import { RocheAnchorNavigationItem } from './anchor-navigation-item';
import { RocheBreadcrumbs } from './roche-breadcrumbs';
import { RocheContactCard } from './contact-card';
import { RocheContactCardPerson } from './contact-card-person';
import { RocheContactList } from './contact-list';
import { RocheCookieBannerLink } from './cookie-banner-link';
import { RocheDownloadTeaser } from './roche-download-teaser';
import { RocheFooter } from './footer';
import { rocheGenericLinkComponents } from './generic-link';
import { RocheGlobalConfig } from './global-config';
import { RocheHeadline } from './headline';
import { RocheHeroFigure } from './roche-hero-figure';
import { RocheHotspotImage } from './hotspot-image';
import { RocheList } from './list';
import { RocheMetroWidget } from './roche-metro-widget';
import { RocheOrderTrainingMaterial } from './order-training-material';
import { RochePictureCredits } from './picture-credits';
import { RochePodigeeEpisode } from './roche-podigee-episode';
import { RocheProductCatalog } from './roche-product-catalog';
import { RocheProductList } from './product-list';
import { RocheRedLetter } from './red-letter';
import { RocheRichtext } from './richtext';
import { RocheSearch } from './roche-search';
import { RocheStockPrice } from './roche-stock-price';
import { RocheStyledText } from './styled-text';
import { RocheTeaser } from './roche-teaser';
import { RocheTeaserMix } from './roche-teaser-mix';
import { RocheTextLink } from './roche-text-link';
import { RocheTooltip } from './tooltip';
import { RocheTrainingMaterial } from './training-material';
import { ScrollTracking } from './scroll-tracking';

// eslint-disable-next-line import/no-default-export
export default {
  ...forms,
  ...gridComponents,
  ...responsiveTable,
  ...rocheGenericLinkComponents,
  AddMoreInput,
  AddToCartButton,
  Aktuelles,
  AlphabeticListing,
  ArticlesOverview,
  BlacktriangleText,
  BusinessCard,
  Cart,
  CategoriesList,
  CognitoRegistration,
  DidArticlePage,
  DidArticlesList,
  DynamicEventTeaser,
  DynamicPodcastTeaser,
  DynamicTeaser,
  HtmlBlob,
  Marketo,
  OrderDetailsForm,
  Page,
  PageEvent,
  PagePressNews,
  PagePressOverview,
  PageProduct,
  PatientenBetroffene,
  PlaceOrderForm,
  ProductCatalog,
  Produkt,
  RocheAnchorNavigationItem,
  RocheBreadcrumbs,
  RocheContactCard,
  RocheContactCardPerson,
  RocheContactList,
  RocheCookieBannerLink,
  RocheDownloadTeaser,
  RocheFooter,
  RocheGlobalConfig,
  RocheHeadline,
  RocheHeroFigure,
  RocheHotspotImage,
  RocheList,
  RocheMetroWidget,
  RocheOrderTrainingMaterial,
  RochePictureCredits,
  RochePodigeeEpisode,
  RocheProductCatalog,
  RocheProductList,
  RocheRedLetter,
  RocheRichtext,
  RocheSearch,
  RocheStockPrice,
  RocheStyledText,
  RocheTeaser,
  RocheTeaserMix,
  RocheTextLink,
  RocheTooltip,
  RocheTrainingMaterial,
  ScrollTracking,
};
